import { DataSetLinkedDataModel } from '../../model/linked-data';
import { LinkedDataModel } from '../../model/linked-data/linked-data.model';
import { DesignObjectMentionMetadataType } from '../../enum/page-mention-metadata-type.enum';

export const isDataSetData = (data: LinkedDataModel): data is DataSetLinkedDataModel => {
  return data && data.type === DesignObjectMentionMetadataType.DataSet;
};
